import request from "@/utils/request";
import Qs from "qs";

const api = {
  Login: "/j_login"
};

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return request({
    url: api.Login + "?" + Qs.stringify(parameter),
    method: "post",
    data: "",
    headers: {
      "Content-Type": "application/json"
    }
  });
}
